import jQuery from 'jquery';
import AOS from 'aos';
import 'slick-carousel/slick/slick.min.js';
import 'bootstrap/dist/js/bootstrap.bundle.min.js'; // Import all of Bootstrap’s JS


jQuery(function ($) {
    "use strict";

    // document.querySelectorAll('.dropdown-toggle').forEach(el => {
    //     const dropdown = new bootstrap.Dropdown(el);

    //     el.addEventListener('click', function (e) {
    //         e.preventDefault();
    //         dropdown.toggle();
    //     });
    // });

    // Fade in content on page load - REQUIRED or content will not display
    const pageLoadTimeout = setTimeout(function () {
        $('body').addClass('delayfade');
    }, 300);


    // Navbar search functionality
    const searchInput = $('header .search-form-wrap input.search-input');

    searchInput.on('focus', function (e) {
        $(this).closest('.search-form-wrap').addClass('searching');
    }).on('focusout', function (e) {
        if ($(this).val() == '') {
            $(this).closest('.search-form-wrap').removeClass('searching');
        }
    });

    $('.search-toggle').on('click', function(e) {
        e.preventDefault();
        const $btn = $(this);
        const $searchField = $('.search-field');
        const $navLogo = $('.header-logo-wrap');
        $searchField.toggleClass('show');
        $navLogo.toggleClass('show');
        $btn.toggleClass('open');
        if ($searchField.hasClass('show')) {
            $searchField.trigger('focus');
        } else {
            $searchField.trigger('blur');
        }
    });
    

    // Insert ['News', 'Support', 'Rebates'] into the header nav
    const headerNav = $('#main-menu');
    const navItems = [
        { text: 'Contact', url: '/contact' },
        { text: 'Support', url: '/support' },
        { text: 'News', url: '/news' }
    ];
    navItems.forEach(item => {
        const navItem = $('<li class="menu-item menu-item-type-custom menu-item-object-custom"></li>');
        const navLink = $(`<a href="${item.url}">${item.text}</a>`);
        navItem.prepend(navLink);
        headerNav.prepend(navItem);
    });

    // animate on scroll init - https://michalsnik.github.io/aos/
    // must init after any slick sliders
    AOS.init({
        offset: 200,
        disable: window.innerWidth < 768,
    });


    /*****************************************************************/
    /********************* LOCATION FUNCTIONALITY ********************/
    /*****************************************************************/
    const $btnLocationTrigger = $('.state-selector-wrap #btnLocationTrigger');
    const $locationModelEl = $('#locationModal');
    let locationModal;

    if (typeof bootstrap !== 'undefined' && bootstrap.Modal) {
        locationModal = new bootstrap.Modal($locationModelEl[0], { backdrop: true, keyboard: true });
    } else if (window.bootstrap && window.bootstrap.Modal) {
        locationModal = new window.bootstrap.Modal($locationModelEl[0], { backdrop: true, keyboard: true });
    } else {
        // Fallback simple implementation so .show()/.hide() behave reasonably when Bootstrap isn't available
        locationModal = {
            show: function() {
                // ensure modal markup is visible and accessible
                $locationModelEl.addClass('show').css('display', 'block').attr('aria-hidden', 'false').attr('aria-modal', 'true');
                // add backdrop and modal-open body class
                if (!$('.modal-backdrop').length) {
                    $('<div class="modal-backdrop fade show"></div>').appendTo(document.body);
                }
                $('body').addClass('modal-open');
            },
            hide: function() {
                $locationModelEl.removeClass('show').css('display', 'none').attr('aria-hidden', 'true').removeAttr('aria-modal');
                $('.modal-backdrop').remove();
                $('body').removeClass('modal-open');
            }
        };
    }
    const $stateSelector = $('#locationModal .states .state-col');
    const $noStateError = $('#locationModal .error-no-state');
    const cookieDaysToLive = 30;
    let selectedState = '';
    let triggeredNavigation = false; // tracks if selection caused a navigation so we avoid reload

    /*********************** COOKIE FUNCTIONS ************************/
    function setCookie(name, value, daysToLive) {
        // Encode value in order to escape semicolons, commas, and whitespace
        let cookie = name + "=" + encodeURIComponent(value);
        let secureAttr = '; secure';

        if (location.protocol !== 'https:') {
            secureAttr = '';
        }

        if (typeof daysToLive === "number") {
            // Set max-age attribute
            cookie += "; max-age=" + (daysToLive * 24 * 60 * 60) + "; path=/; SameSite=Lax" + secureAttr;

            document.cookie = cookie;
        }
    }

    function getCookie(name) {
        // Split cookie string and get all individual name=value pairs in an array
        let cookieArr = document.cookie.split(";");

        // Loop through the array elements
        for (let i = 0; i < cookieArr.length; i++) {
            let eqIdx = cookieArr[i].indexOf("=");
            if (eqIdx === -1) {
                continue;
            }

            // Trim cookie name and compare
            if (name == cookieArr[i].slice(0, eqIdx).trim()) {
                // Decode cookie and return (malformed encoding is treated as unset)
                try {
                    return decodeURIComponent(cookieArr[i].slice(eqIdx + 1));
                } catch (e) {
                    return null;
                }
            }
        }

        // Return null if not found
        return null;
    }

    // Check if cookie exists and trigger modal if not or setup data if so
    function checkCookie(name) {

        let cookieCheck = getCookie(name);

        // Only accept known states; anything else is treated as unset
        if (cookieCheck !== null) {
            cookieCheck = cookieCheck.trim().toLowerCase();
            if (['utah', 'idaho', 'wyoming'].indexOf(cookieCheck) === -1) {
                cookieCheck = null;
            }
        }

        if (cookieCheck === null || cookieCheck === '') {

            if ($('body.single-rebates').length) {

                setCookie("selectedState", $('main').data('rebateLocation'), cookieDaysToLive);
                setupDataPerState($('main').data('rebateLocation'));

            } else {

                // Cached HTML may show a stale state icon; reset to the default (no state) variant
                $btnLocationTrigger.find('[data-state-variant]').each(function () {
                    $(this).prop('hidden', $(this).data('stateVariant') !== 'none');
                });
                filterStateDropdownItems('');

                locationModal.show();

            }

        } else {

            if ($('body.single-rebates').length) {

                setCookie("selectedState", $('main').data('rebateLocation'), cookieDaysToLive);
                setupDataPerState($('main').data('rebateLocation'));

            } else if( $('body.archive.tax-rebate_categories').length ) {

                setupDataPerState(cookieCheck);
                refreshRebates(cookieCheck);

            } else {

                setupDataPerState(cookieCheck);

            }

        }
    }
    /********************* END COOKIE FUNCTIONS **********************/

    // Show state-restricted dropdown items (e.g. multifamily) only for the selected state.
    // Done client-side because the page HTML may be served from a full-page cache.
    function filterStateDropdownItems(state) {
        const codes = { utah: 'ut', idaho: 'id', wyoming: 'wy' };
        const code = codes[state] || '';

        $('[data-dropdown-states]').each(function () {
            const allowed = String($(this).data('dropdownStates')).split(',');
            $(this).prop('hidden', !code || allowed.indexOf(code) === -1);
        });
    }

    // setup data per location cookie
    function setupDataPerState(state) {

        selectedState = state.toLowerCase();
        filterStateDropdownItems(selectedState);
        $btnLocationTrigger.find('[data-state-variant]').each(function () {
            $(this).prop('hidden', $(this).data('stateVariant') !== selectedState);
        });
        $btnLocationTrigger.find('.location-text').text(state);
        // modal options are set when the modal instance is created; avoid touching internal _config directly

        $stateSelector.each(function () {
            if ($(this).data('stateLocation') == selectedState) {
                $(this).addClass('selected-state');
            }
        });

        // update body class with current location for css hook
        $('body').removeClass(function (index, className) {

            return (className.match(/(^|\s)location-\S+/g) || []).join(' ');

        }).addClass('location-' + state);

        // Update the navbar location trigger so the icon updates accordingly.
        // Remove any previous location-* classes and add the new one.
        // Keep the "location-btn" styling class.
        $btnLocationTrigger.removeClass(function(index, className) {
            return (className.match(/(^|\s)location-(?!btn(\s|$))\S+/g) || []).join(' ');
        }).addClass('location-' + state.toLowerCase());

        // Set a data attribute on the trigger for easier CSS/hooks
        $btnLocationTrigger.attr('data-state', state.toLowerCase());

        // Try to pick up a state icon defined on the modal's state element via data-state-icon or data-stateIcon
        var $stateEl = $stateSelector.filter(function() {
            return $(this).data('statelocation') == selectedState || $(this).data('stateLocation') == selectedState;
        }).first();

        if ($stateEl.length) {
            var iconUrl = $stateEl.data('stateIcon') || $stateEl.data('state-icon') || null;

            if (iconUrl) {
                // If the trigger contains an <img class="state-icon">, update its src
                var $img = $btnLocationTrigger.find('img.state-icon');
                if ($img.length) {
                    $img.attr('src', iconUrl);
                } else {
                    // Otherwise, set a background-image on an element with class .state-icon if present
                    var $wrap = $btnLocationTrigger.find('.state-icon');
                    if ($wrap.length) {
                        $wrap.css('background-image', 'url("' + iconUrl + '")');
                    }
                }
            }
        }
    }

    // refresh rebates if user is on rebate archive page using ajax call
    function refreshRebates(state) {

        $.ajax({
            type: 'POST',
            url: '/wp-admin/admin-ajax.php' + '?t=' + Date.now(),
            async: false,
            cache: false,
            dataType: 'html',
            data: {
                action: 'hrl_refresh_rebates',
                state: state,
                category: $('.rebates-wrap').data('category'),
            },
            success: function (res) {
                $('.rebates-wrap .row').html(res);
            },
            error: function (err) {
                console.error(err);
            }
        });

    }

    function stripParams(url) {
        return url.split('?')[0];
    }

    // Displays alert notification banners at bottom of page
    function displayAlertBanners() {
        $('.alert-banner').hide();

        var bodyClass = $('body').attr('class');
        var state = '';

        if (bodyClass.includes('location-idaho')) {
            state = 'idaho';
        } else if (bodyClass.includes('location-utah')) {
            state = 'utah';
        } else if (bodyClass.includes('location-wyoming')) {
            state = 'wyoming';
        }

        $.ajax({
            type: 'POST',
            url: ajax_object.ajaxurl,
            data: {
                action: 'check_alert_notifications',
                state: state,
                current_page_url: stripParams(window.location.href),
                nonce: ajax_object.nonce,
            },
            success: function(response) {
                if (response) {
                    $('body').append(response);
                }

                $('.close-banner').on("click", function() {
                    $('.alert-banner').hide();
                });
            }, error: function(err) {
                console.error(err);
            }
        });
    }

    // trigger location modal for user to select or change location
    $stateSelector.on("click", function (e) {
        const $curr = $(e.currentTarget);

        if (!$curr.hasClass('selected-state')) {
            $stateSelector.removeClass('selected-state');
            $curr.addClass('selected-state');
            selectedState = $curr.data('stateLocation');
            $noStateError.addClass('d-none');

            // Automatically apply selection and close modal
            // Reuse the confirm button logic to ensure cookies, UI updates, and any refresh actions run
            stateSelectedRefreshTasks();
        }
    });

    // confirm location selected from location modal
    // Persist via the server first (Set-Cookie header avoids Safari's 7-day cap on JS cookies), then continue.
    // setCookie remains as a fallback so the selection still works if the request fails.
    function stateSelectedRefreshTasks() {
        const state = String(selectedState || '').toLowerCase();

        if (!state) {
            runStateSelectedTasks();
            return;
        }

        $.ajax({
            type: 'POST',
            url: ajax_object.ajaxurl,
            timeout: 3000,
            data: { action: 'hrl_set_selected_state', state: state },
            complete: runStateSelectedTasks
        });
    }

    function runStateSelectedTasks() {

        // reset navigation flag for this selection
        triggeredNavigation = false;

        if (selectedState != '') {
            let prevState = $('#btnLocationTrigger .location-text').text().toLowerCase();

            $btnLocationTrigger.find('.location-text').text(selectedState);
            setCookie("selectedState", selectedState, cookieDaysToLive);
            setupDataPerState(selectedState);

            // refresh rebates if on archive page using ajax function
            if ($('body.archive.tax-rebate_categories section.posts-wrap.rebates-wrap').length) {
                refreshRebates(selectedState);
            }

            // trigger backlink if on single rebate template and that link exists (otherwise navigate home)
            if ($('body.single-rebates').length) {

                if (prevState !== selectedState) {

                    // map full state name to abbreviation used in URLs
                    const stateAbbrMap = {
                        'utah': 'ut',
                        'idaho': 'id',
                        'wyoming': 'wy'
                    };

                    const abbr = stateAbbrMap[selectedState.toLowerCase()] || selectedState.slice(0,2).toLowerCase();

                    try {
                        const u = new URL(window.location.href);

                        // remove existing suffix -id/-ut/-wy from the pathname and append the new abbreviation
                        let p = u.pathname.replace(/-(id|ut|wy)(?=\/|$)/i, '');
                        // ensure no trailing slash for consistent behavior
                        p = p.replace(/\/$/, '');
                        // append new abbreviation
                        p = p + '-' + abbr;

                        u.pathname = p;

                        triggeredNavigation = true;
                        window.location.href = u.toString();
                        return;
                    } catch (err) {
                        // fallback if URL parsing fails - do a string replace on href
                        let href = window.location.href;
                        href = href.replace(/-(id|ut|wy)(?=\/?|$)/i, '-' + abbr);

                        if (href === window.location.href) {
                            // no replace happened, insert before query/hash
                            const qIdx = href.search(/[?#]/);
                            const base = qIdx === -1 ? href : href.slice(0, qIdx);
                            const rest = qIdx === -1 ? '' : href.slice(qIdx);
                            href = base.replace(/\/$/, '') + '-' + abbr + rest;
                        }

                        triggeredNavigation = true;
                        window.location.href = href;
                        return;
                    }
                }
            }

            // If user is on multifamily state pages, switch to the matching destination when state changes.
            if ($('body.page-template-page-multifamily').length || $('body.page-idaho-multifamily').length || $('body.page-wyoming-multifamily').length || $('body.page-utah-multifamily').length) {
                const multifamilyTargets = {
                    'idaho': '/idaho-multifamily',
                    'wyoming': '/wyoming-multifamily',
                    'utah': 'https://www.rockymountainpower.net/savings-energy-choices/home/utah-multifamily-program.html'
                };

                const targetUrl = multifamilyTargets[selectedState.toLowerCase()] || '';

                if (targetUrl) {
                    const currentPath = window.location.pathname.replace(/\/$/, '').toLowerCase();
                    const targetPath = targetUrl.indexOf('http') === 0
                        ? targetUrl
                        : targetUrl.replace(/\/$/, '').toLowerCase();

                    if (targetUrl.indexOf('http') === 0 || currentPath !== targetPath) {
                        triggeredNavigation = true;
                        window.location.href = targetUrl;
                        return;
                    }
                }
            }

            locationModal.hide();

            // Ensure any leftover backdrop or modal-open class is removed (safety cleanup)
            setTimeout(function() {
                $('.modal-backdrop').remove();
                $('body').removeClass('modal-open');

                // If we didn't already navigate away, reload the page so content reflects the new state
                if (!triggeredNavigation) {
                    location.reload();
                }
            }, 10);

        } else {

            $noStateError.removeClass('d-none');

        }

        // update result count for search page
        if ($('body.search').length) {
            countSearchItems();
        }

        displayAlertBanners();

    }

    // CHECK IF STATE HAS BEEN SELECTED & SETUP ACCORDINGLY
    checkCookie('selectedState');

    /********************** END LOCATION FUNCTIONALITY *********************/



    /***********************************************************************/
    /************************ LOCATION FUNCTIONALITY ***********************/
    /***********************************************************************/
    function countSearchItems() {
        let itemCount;
        const $searchResultNumber = $('#search-result-number');

        itemCount = $('.search-item.std-item').length;

        if ($('body.location-utah').length) {
            itemCount += $('.search-item.location-utah').length;
        }

        if ($('body.location-idaho').length) {
            itemCount += $('.search-item.location-idaho').length;
        }

        if ($('body.location-wyoming').length) {
            itemCount += $('.search-item.location-wyoming').length;
        }

        $searchResultNumber.text(itemCount);
    }

    if ($('body.search').length) {

        countSearchItems();
    }
    /*********************** END SEARCH FUNCTIONALITY **********************/


    // Prevent text widows on targetted elements
    //https://matmartin.co.uk/blog/code-prevent-widows-and-orphans-web-layouts/
    $('.no-orphans, .no-child-orphans p').each(function () {
        let string = $(this).html();
        string = string.replace(/ ([^ ]*)$/, '&nbsp;$1');
        $(this).html(string);
    });

    displayAlertBanners();

    /***********************************************************************/
    /************************ SELF AUDIT LINK ******************************/
    /***********************************************************************/

    const submitBtn = $('#customerID-submit');

    submitBtn.on('click', get_assessment_link);

    function extractUrl(text) {
        var urlRegex = /(https?:\/\/[a-zA-Z0-9\-._~:\/?#[\]@!$&'()*+,;=%]+)/g;
        var url = text.match(urlRegex);
        return url ? url[0] : null;
    }

    function get_assessment_link() {

        let customerID = $('#customerID').val();

        jQuery.ajax({
            url: ajax_object.ajaxurl,
            type : 'post',
            data : {
                action : 'techsee_api_get_audit_link',
                customerID : customerID,
            },

            success: function( response ) {
                const techseeLink = extractUrl(response.sessionLink);
                const tableWrap = $('#response-wrap');
                const table = $(`<table><tr><th>Customer ID</th><td>${response.customerID}</td></tr><tr><th>Assessment Link</th><td><a href="${techseeLink}">${techseeLink}</a></td><tr/>`);

                tableWrap.empty();
                tableWrap.append(table);
            }
        });
    }

    if ($('body.single-rebates').length) {
        $('a[href="https://wattsmarthomes.capturesportal.com/Public/tradeallysearch/findatradeally"]').attr('href', '/find-a-contractor');
    }


    /***********************************************************************/
    /************************ SINGLE REBATES *******************************/

    // when clicking on a .tabs-header, activate the matching tab-content using data-tab attribute
    function prepTabsSection() {

        const $tabHeaders = $('.tabs-header');
        const $tabContents = $('.tab-content');

        $tabHeaders.on('click', function (e) {
            const $clicked = $(this);
            const target = $clicked.data('tab');

            if (!target) return;

            // deactivate all headers and contents
            $tabHeaders.removeClass('active');
            $tabContents.removeClass('active');

            // activate the clicked header and the matching content
            $clicked.addClass('active');
            $tabContents.filter('[data-tab="' + target + '"]').addClass('active');
        });

        // Optional: allow linking to a tab via URL hash like #tab=application-details
        (function() {
            const params = new URLSearchParams(window.location.search);
            const tabFromQuery = params.get('tab');
            if (tabFromQuery) {
                const $header = $tabHeaders.filter('[data-tab="' + tabFromQuery + '"]').first();
                if ($header.length) {
                    $header.trigger('click');
                }
            }
        })();
    };

    prepTabsSection();

});